import Button from '@doordash/component-button'
import { StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { OrientationTitle, OrientationTypeContainer } from './styles'
import { OrientationProps } from './types'

const OrientationType = ({
  title,
  buttonName,
  eventName,
  supplyAcquisitionMethod,
  trackDropshippingEvent,
  setSupplyAcquisitionMethod,
}: OrientationProps) => (
  <OrientationTypeContainer>
    <StackChildren>
      <OrientationTitle>{title}</OrientationTitle>
      <Button
        type={Button.Types.PrimaryPill}
        onClick={() => {
          trackDropshippingEvent(eventName)
          setSupplyAcquisitionMethod(supplyAcquisitionMethod)
        }}
      >
        {buttonName}
      </Button>
    </StackChildren>
  </OrientationTypeContainer>
)

export default OrientationType
